import React from 'react';

interface Props {
  open: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const ConfirmActionModal: React.FC<Props> = ({ open, title = 'Confirme a ação', message = 'Tem certeza que deseja executar esta ação?', confirmLabel = 'Confirmar', cancelLabel = 'Cancelar', onConfirm, onCancel, loading = false }) => {
  if (!open) return null;

  // Auto-detect whether the confirm action is an approval so we can show a green button for "Aprovar"
  const lower = (confirmLabel || title || '').toLowerCase();
  const isApprove = /aprovar|aprovação|aprovação|aprovação/i.test(lower) || lower.includes('aprovar');

  const confirmClasses = isApprove
    ? 'px-3 py-2 rounded bg-emerald-600 text-white text-sm hover:bg-emerald-700 disabled:opacity-50'
    : 'px-3 py-2 rounded bg-red-600 text-white text-sm hover:bg-red-700 disabled:opacity-50';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-5">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">{title}</h3>
        <p className="text-sm text-gray-600 mb-4">{message}</p>
        <div className="flex justify-end gap-2">
          <button onClick={onCancel} className="px-3 py-2 rounded bg-white border text-sm">
            {cancelLabel}
          </button>
          <button onClick={onConfirm} disabled={loading} className={confirmClasses}>
            {loading ? 'Processando...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;
